import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
	selector: 'advalvas-detail-modal',
	templateUrl: 'advalvas-detail-modal.html'
})
export class AdvalvasDetailModalComponent {

	private advItem: any;

	constructor(
		private viewCtrl : ViewController,
		private navParams: NavParams
	) {
		this.advItem = JSON.parse(JSON.stringify(this.navParams.get('data')));
	}

	closeModal() {
		this.viewCtrl.dismiss();
	}

}



// WEBPACK FOOTER //
// ./src/components/advalvas-detail-modal/advalvas-detail-modal.ts